import { Component, inject, OnDestroy, signal, ChangeDetectionStrategy } from '@angular/core';
import { ApplicationContextStore, OnReAttach, WebLoadingService } from '@raptor-fe/services';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import { getErrorMessages } from '@raptor-fe/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '',
})
export class WebBaseComponent implements OnDestroy, OnReAttach {
    protected isLoaded$ = signal(false);
    protected tenantId: string;
    protected branchId: string;
    protected destroySubject = new Subject<void>();

    protected readonly applicationContextStore = inject(ApplicationContextStore);
    protected readonly location = inject(Location);
    protected readonly loading = inject(WebLoadingService);

    constructor() {
        this.branchId = this.applicationContextStore.branch().id as string;
        this.tenantId = this.applicationContextStore.tenantId();
    }

    ngOnDestroy(): void {
        this.destroySubject.next();
        this.destroySubject.complete();
    }

    goBack(): void {
        this.location.back();
    }

    onReAttach(): void {
        // List screens override this to reload after CustomReuseStrategy restores a cached route.
    }

    showLoading(): void {
        this.loading.setLoading(true, this.constructor.name);
    }

    hideLoading(): void {
        this.loading.setLoading(false, this.constructor.name);
    }

    getErrorMessages(control?: AbstractControl): string | undefined {
        return getErrorMessages(control);
    }
}